export const CREATE_WEBINAR_DETAILS= "CREATE_WEBINAR_DETAILS";
export const  CREATE_WEBINAR_SESSIONS= " CREATE_WEBINAR_SESSIONS";
export const  CREATE_WEBINAR_PRICING= " CREATE_WEBINAR_PRICING";
export const  CREATE_WEBINAR_FAQS= " CREATE_WEBINAR_FAQS";
export const GOT_ALL_WEBINARS= "GOT_ALL_WEBINARS";
export const SAVE_WEBINAR_DRAFT = "SAVE_WEBINAR_DRAFT";
export const GOT_WEBINAR_DATA = "GOT_WEBINAR_DATA";
export const GOT_WEBINAR_DATA_COURSE_ID = "GOT_WEBINAR_DATA_COURSE_ID";


export const EDITED_WEBINAR_DETAILS= "EDITED_WEBINAR_DETAILS";

export const EDITED_WEBINAR_PRICING = "EDITED_WEBINAR_PRICING";

export const POPULATE_SESSIONS= "POPULATE_SESSIONS";
export const POPULATE_PRICE_PLAN  = "POPULATE_PRICE_PLAN";
export const CREATE_WEBINAR_AND_SESSIONS = "CREATE_WEBINAR_AND_SESSIONS";

export const INCREMENT_SESSION_COUNT = "INCREMENT_SESSION_COUNT";
export const DECREMENT_SESSION_COUNT = "DECREMENT_SESSION_COUNT";
export const SET_SESSION_COUNT = "SET_SESSION_COUNT";
export const SET_NO_OF_SESSIONS = "SET_NO_OF_SESSIONS";

export const DOWNLOAD_WEBINAR_ATTENDEE_SHEET_SUCCESS = "DOWNLOAD_WEBINAR_ATTENDEE_SHEET_SUCCESS";
export const DOWNLOAD_WEBINAR_ATTENDEE_SHEET_FAILURE = "DOWNLOAD_WEBINAR_ATTENDEE_SHEET_FAILURE";
